export default __webpack_public_path__ + "images/8aadf85dfad0e3254f73485b3e4a73fc-nye_collections_touchpoint_image.webp";